import React, { useRef, useEffect, useCallback, useState } from 'react';
import AudioRecorder from "components/utils/AudioRecorder";
import Chip from '@mui/material/Chip';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { PictureAsPdf } from '@material-ui/icons'; 
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'; 
import { TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Textarea from '@mui/joy/Textarea';
import { Box } from '@mui/material';
import 'css/generalSettings.css';
import MenuItem  from "@mui/material/MenuItem"; 
import { successErrorAction, warningErrorAction } from 'actions/ErrorActions';
import { helpHttp } from 'service/HelpHttp';
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews"; 
import { ENDPOINT} from "constants/variables";
import image1 from "components/photos/sidebars/takephoto.jpeg";
import PropTypes from 'prop-types';

const initialStateEMAIL = {
  "id":"",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "", 
  "createdate": null,
  "emailto":"gestrescan@gmail.com",
  "subjectEmail":"", 
  "contentEmail":"",
  "resolution":"",
  "slatype_id":0,
  "slatype_namees": "",
  "slatype_nameen": "",
  "incidenttype_id":1, 
  "incidenttype_namees": "",
  "incidenttype_nameen": "",
  "resolution_id":0, 
  "resolution_namees": "",
  "resolution_nameen": "",
  "formdi_id":0, 
  "ownformdi_id": "",
  "numberDI_sheet": "",
  "isfinished": false,
  "hasbeenread": false,
  "updatedFiles":[]
};

const initialTypesToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": ""
}];

const initialDefaultTypesToSelect = {
  "id": "1",
  "code": "",
  "namees": "",
  "nameen": ""
};
     
const initialEmailToSelect = [{
  "id": "",
  "email": "" 
}];

const SendEMAILToSystem = ({ id, showModalSentInicidents }) => {
  const { t,i18n } = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token);  
  const defaultStore_id = useSelector((state) => state.loginUser.defaultStore.id);  
  const defaultStore_username = useSelector((state) => state.loginUser.defaultStore.tradename);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const useraccount_username = useSelector((state) => state.loginUser.username);  
  const footeremail = useSelector((state) => state.formatDIUser.footeremail);  
  const [formEMAIL, setFormEMAIL] = useState(initialStateEMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [incidenteTypeToSelect,setIncidenteTypeToSelect]= useState(initialTypesToSelect); 
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [emailToSelect,setEmailToSelect]= useState(initialEmailToSelect);  
  const [filteredEmail, setFilteredEmail] = useState([]); // Opciones filtradas
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1); // Índice de la opción resaltada 
  const [files, setFiles] = useState([]); 
  const [filesImages, setFilesImages] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [defaultIncidenteType, setDefaultIncidenteType] = useState(initialDefaultTypesToSelect); 
  const videoRef = useRef(null);
  const canvasRef = useRef(null); 

  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape') {
        if (showCameraModal) {
          const video = videoRef.current;
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
          }
          setShowCameraModal(false);
          return; // no cierres todo el Drawer
        } 
        if (showModalSentInicidents) {  
          setFormEMAIL(initialStateEMAIL);
          setErrorsEMAIL({});
          setIncidenteTypeToSelect(initialTypesToSelect);
          setDefaultIncidenteType(initialDefaultTypesToSelect);
          setPreviewImage(null);
          setFiles([]);
          setFilesImages([]);
          dispatch(setLoading(false));  
          setEmailToSelect(initialEmailToSelect);
          setFilteredEmail([]);
          setHighlightedIndexEmail(-1); 
          navigate("/home"); 
          return () => {};
        } 
      }
    },
    [
      setFormEMAIL,
      setErrorsEMAIL,
      setIncidenteTypeToSelect,
      setDefaultIncidenteType,
      setFiles,
      setFilesImages,
      setPreviewImage,
      showCameraModal,
      setEmailToSelect,
      setFilteredEmail,
      setHighlightedIndexEmail,
      showModalSentInicidents, 
      dispatch,
      navigate
    ]
  );

  const closeModalSendEMAILToSystem = () => {
     if (showCameraModal) {
        const video = videoRef.current;
        if (video && video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
        }
        setShowCameraModal(false);
        return; // no cierres todo el Drawer
      } 
      setFormEMAIL(initialStateEMAIL);
      setErrorsEMAIL({});
      setIncidenteTypeToSelect(initialTypesToSelect);
      setDefaultIncidenteType(initialDefaultTypesToSelect);
      setFiles([]);
      setFilesImages([]);
      setPreviewImage(null);
      setEmailToSelect(initialEmailToSelect);
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1); 
      dispatch(setLoading(false));   
      navigate("/home"); 
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchEmail= useDebounce((searchValue) => {
    const upperValue = searchValue.toLowerCase();
    if (upperValue.trim() === "") {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    const filtered = emailToSelect
        .filter(store => store && store.email)
        .filter(store => {
        const emails = store.email.toLowerCase();
        return emails.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
      setFilteredEmail(filtered);
      setHighlightedIndexEmail(0);
  }, 300);  
  const handleSelectEmail = (email) => {
    if (!email) return; // Validación adicional para evitar errores
    setFormEMAIL((formEMAIL) => ({
      ...formEMAIL,
      emailto: email.email || ""
      
    }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }; 

  const handleKeyDownEmail = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredEmail.length === 0 && formEMAIL.emailto.trim() === "") {
        setFilteredEmail(emailToSelect);
        setHighlightedIndexEmail(0);
      } else {
        setHighlightedIndexEmail((prevIndex) => {
          const nextIndex = prevIndex < filteredEmail.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexEmail((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
      if (highlightedIndexEmail >= 0 && highlightedIndexEmail < filteredEmail.length) {
        handleSelectEmail(filteredEmail[highlightedIndexEmail]);
      }
    } else if (event.key === "Escape") {
      const isValid = emailToSelect.some((email) => {
        if (!email || !email.workplace) return false; 
        const normalizedEmail = email.email.toLowerCase();
        const normalizedInputEmail = formEMAIL.emailto.toLowerCase();
        return normalizedEmail === normalizedInputEmail;
      }); 
      if (!isValid) {
        setFormEMAIL((formEMAIL) => ({
          ...formEMAIL,
          emailto: "",
        }));
      } 
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  };

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
  const handleBlur = useCallback((event) => {
      if (!event || !event.currentTarget) return;
      // Asegúrate de que no se cierra si haces clic en un elemento de la lista
      if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  }, []);
    
  const handleAddImage = (newFiles) => {
    newFiles = newFiles.filter((file) => !filesImages.find((f) => f.data === file.data));
    setFilesImages([...filesImages, ...newFiles]);
  };

  const handleDeleteImage = (deleted) => {
    setFilesImages(filesImages.filter((f) => f !== deleted));
  };
 
  useEffect(() => {
    if (showCameraModal && videoRef.current) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          videoRef.current.srcObject = stream;
        })
        .catch(err => {
          dispatch(warningErrorAction(t('Text_CameraNotAccessible')));
          setShowCameraModal(false);
        });
    }
  }, [showCameraModal, dispatch, t]);
  
  const handleBlurDataEditEmail = (e) => {
    handleChangeDataEditEmail(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditEmail = (e) => {
    const { name, value } = e.target;
    setFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      [name]: value,
    })); 
  };

  const handleBlurInicidentType = (e) => {
    handleChangeInicidentType(e); 
  };

  const handleChangeInicidentType = (event) => {
    const selectedId = event.target.value;
    const selectedOption = incidenteTypeToSelect.find((option) => option.id.toString() === selectedId.toString());
    if (selectedOption) {
      setFormEMAIL((prev) => ({
        ...prev,
        incidenttype_id: selectedOption.id,
        incidenttype_namees: selectedOption.namees,
        incidenttype_nameen: selectedOption.nameen,
      }));
    }else{
      setFormEMAIL((prev) => ({
        ...prev,
        incidenttype_id: defaultIncidenteType.id,
        incidenttype_namees: defaultIncidenteType.namees,
        incidenttype_nameen: defaultIncidenteType.nameen,
      }));
    }
  };

  const validateFormEmail = () => {
    let errorsEMAIL = {}; 
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

     if (!formEMAIL.emailto || formEMAIL.emailto==="") {
      errorsEMAIL.emailto = 'Text_FieldSendEmailToRequired'; 
    } else {
      if (regexInvalidCharacters.test(formEMAIL.emailto)) {
        errorsEMAIL.emailto = 'Text_TextNoValid';
      }
    }  

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail)) {
      errorsEMAIL.subjectEmail = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formEMAIL.contentEmail)) {
      errorsEMAIL.contentEmail = 'Text_TextNoValid';
    }  
    if (formEMAIL.contentEmail===undefined || formEMAIL.contentEmail===null || formEMAIL.contentEmail===""){
      errorsEMAIL.contentEmail = 'Text_SENDEMAIL_ContentEmail_Required';
    }
    return errorsEMAIL;
  };

  const handleConfirmFetchSendInicidents = (dataToSend) => { 
    const fetchData = async () => { 
      closeModalSendEMAILToSystem(); 
      try {
        const getData = await helpHttp().post(ENDPOINT, `incidentemail/savesentqueryincident`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(setLoading(false));
          dispatch(successErrorAction(t('Text_SendData')));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.cause)));
        } 
      } catch (error) { 
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }   
      return () => {  };
    }; 
    fetchData();  
  };

  const splitFileBase64=(fileToConvert)=>{    
    var arrayAuxiliar=[];
    arrayAuxiliar=fileToConvert.split(',')
    return arrayAuxiliar[1];
  } 

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]; // solo el contenido base64
        resolve(base64);
      };
    reader.onerror = (error) => reject(error);
    }
  );

  const buildUpdatedFiles = async () => {
    const updatedFiles = await Promise.all(
      files.map(async (item, index) => {
        const file = item.file || item; // por si viene directo del input
        const base64 = await toBase64(file);
        return {
          id: index,
          incidents_id:null,
          pathdocument: null, // el backend lo genera
          relativepathdocument: null, // el backend lo genera
          filename: file.name,
          createdate: file.lastModified,
          datafile: base64,
          type: file.type,
          sourcepath: null // el backend lo genera
        };
      })
    );
    return updatedFiles;
  };

  const buildUpdatedFilesImages = async () => {
    const updatedFiles = await Promise.all(
      filesImages.map((file, index) => ({
        id: null, // es nuevo, por lo que no tiene ID
        incidents_id:null,
        pathdocument: null, // el backend lo genera
        relativepathdocument: null, // el backend lo genera
        filename: file.file?.name || `image_${index + 1}.jpg`,
        createdate: new Date(),
        datafile:splitFileBase64(file.data), // base64 del archivo
        type: file.file?.type || "image/jpeg",
        sourcepath: null // el backend lo genera
      }))
    );
    return updatedFiles;
  }; 

  const handleSubmitDataEdit = async () => {
    const errors = validateFormEmail();
    setErrorsEMAIL(errors); 
    if (
      Object.keys(errors).length === 0 &&
      defaultStore_id &&
      useraccount_id &&
      formEMAIL.emailto &&
      formEMAIL.emailto !== "" &&
      formEMAIL.contentEmail !== ''
    ) {
      dispatch(setLoading(true));
      let updatedFiles = [];
      let updatedFilesImages = [];
      if (files.length > 0) {
        updatedFiles = await buildUpdatedFiles();
      } 
       if (filesImages.length > 0) {
        updatedFilesImages = await buildUpdatedFilesImages();
      } 
      const updatedForm = {
        "id":"",
        "defaultStore_id":formEMAIL.defaultStore_id, 
        "tradename":formEMAIL.tradename,
        "useraccount_id":formEMAIL.useraccount_id,
        "username":formEMAIL.username, 
        "createdate":formEMAIL.createdate,
        "emailto":formEMAIL.emailto,
        "subjectEmail":formEMAIL.subjectEmail, 
        "contentEmail":formEMAIL.contentEmail,
        "resolution":formEMAIL.resolution,
        "slatype_id":formEMAIL.slatype_id,
        "slatype_namees":formEMAIL.slatype_namees,
        "slatype_nameen":formEMAIL.slatype_nameen,
        "incidenttype_id":formEMAIL.incidenttype_id, 
        "incidenttype_namees":formEMAIL.incidenttype_namees,
        "incidenttype_nameen":formEMAIL.incidenttype_nameen,
        "resolution_id":formEMAIL.resolution_id,
        "resolution_namees": formEMAIL.resolution_namees,
        "resolution_nameen": formEMAIL.resolution_nameen,
        "formdi_id":formEMAIL.formdi_id,
        "ownformdi_id": formEMAIL.ownformdi_id,
        "numberDI_sheet": formEMAIL.numberDI_sheet,
        "isfinished": formEMAIL.isfinished,
        "hasbeenread": formEMAIL.hasbeenread,
        "updatedFiles": [...updatedFiles, ...updatedFilesImages]
      };
      setFormEMAIL(updatedForm);
      handleConfirmFetchSendInicidents(updatedForm);
    } else {
      if (errors.emailto) {
        dispatch(warningErrorAction(t(errors.emailto)));
      } else if (errors.contentEmail) {
        dispatch(warningErrorAction(t(errors.contentEmail)));
      
      } else if (errors.contentEmail) {
        dispatch(warningErrorAction(t(errors.contentEmail)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    } 
  };
  
  const handlePreviewIcon = (fileObject) => {
    const { type } = fileObject.file; 
    if (type.startsWith('audio/')) {
      // Previene Dropzone de intentar crear un blob inválido
      return null;
    }
    switch (type) {
      case 'application/pdf':
        return (
          <Box sx={{ bgcolor: '#00000', width: 200, height: 150, padding: '4px' }}>
            <PictureAsPdf style={{ color: '#e74a3b', width: 50, height: 50 }} />
            <br />
            <br />
            <Chip
              value={fileObject.file.name}
              label={fileObject.file.name}
              clickable={false}
              style={{ color: '#e74a3b', fontSize: 8 }}
            />
          </Box>
        );
      default:
        return (
          <Box sx={{ bgcolor: '#00000', width: 200, height: 150, padding: '4px' }}>
            <PictureAsPdf style={{ color: '#e74a3b', width: 50, height: 50 }} />
            <br />
            <br />
            <Chip
              value={fileObject.file.name}
              label={fileObject.file.name}
              clickable={false}
              style={{ color: '#e74a3b', fontSize: 8 }}
            />
          </Box>
        );
    }
  }; 

  const handleAddFileContract = (newFiles) => {
    newFiles = newFiles.filter((file) => !files.find((f) => f.data === file.data));
    setFiles([...files, ...newFiles]);
  };

  const handleDeleteFileContract = (deleted) => {
    setFiles(files.filter((f) => f !== deleted));
  }; 

  useEffect(() => {
    let isMounted = true;  
    const fetchDataIncident = async () => {
      try {
        const getData =  await helpHttp().get(ENDPOINT,`incidenttype/incidenttypesorderbynamees`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setIncidenteTypeToSelect(getData);
          if (getData?.length > 0){
            let defaultOption = incidenteTypeToSelect?.find((option) => option.code?.toString() === "00000");
            if (!defaultOption) {
              defaultOption = incidenteTypeToSelect[0]
            }
            setDefaultIncidenteType((prev) => ({
              ...prev,
              id: defaultOption.id,
              code: defaultOption.code,
              namees: defaultOption.namees,
              nameen: defaultOption.nameen,
            })); 
          }
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (showModalSentInicidents ) { 
      fetchDataIncident();
      if (id!=="0"){
        if (formEMAIL.id===""){
          //fetchDataForm();  
        }
      }else{
        setFormEMAIL(initialStateEMAIL);
           setFormEMAIL(formEMAIL => ({
          ...formEMAIL,
          id:0,
          defaultStore_id:defaultStore_id,
          tradename:defaultStore_username,
          useraccount_id:useraccount_id, 
          username:useraccount_username,  
          createdate: new Date(),
          emailto:"gestrescan@gmail.com",
           subjectEmail:"LE REMITO LA SIGUIENTE INCIDENCIA",
          contentEmail:footeremail,
          resolution:"",
          slatype_id: 1 ,
          slatype_namees:  "" ,
          slatype_nameen: "" ,
          incidenttype_id: defaultIncidenteType.id ,
          incidenttype_namees: defaultIncidenteType.namees ,
          incidenttype_nameen: defaultIncidenteType.nameen,
          resolution_id: 1 ,
          resolution_namees:  "" ,
          resolution_nameen: "" ,
          formdi_id: 0 ,
          ownformdi_id: 0 ,
          numberDI_sheet: "" ,
          isfinished: false,
          hasbeenread: false,
          updatedFiles:[]
        }));
      }
    }  
    return () => { isMounted = false };
  }, [dispatch,t,token,defaultStore_id,id,defaultStore_username,useraccount_id,useraccount_username,footeremail,formEMAIL.id,showModalSentInicidents,
    defaultIncidenteType.id,defaultIncidenteType.nameen,defaultIncidenteType.namees,incidenteTypeToSelect
  ]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]); 

  useEffect(() => {
    let isMounted = true; 
    const fetchDataEmail = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`api/getlistemails/`,token,
          (formEMAIL.emailto!==undefined && formEMAIL.emailto!==null && formEMAIL.emailto.replace(/[.;\-/\\|]/g, "").trim()!=="")?formEMAIL.emailto.replace(/[.;\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setEmailToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalSentInicidents && formEMAIL.emailto && formEMAIL.emailto.replace(/[.;\-/\\|]/g, "").trim()!=="") { 
      fetchDataEmail();
    }else{
      setEmailToSelect(initialEmailToSelect);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,showModalSentInicidents,formEMAIL.emailto]);


  return (
    <div>
      {showModalSentInicidents && (
        <div className="container-fluid formgeneral-send-wrapper">
          {/* Search input */}
          <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}>
             <div className="formgeneral-card-header">
              {/* HEADER */}
              <div className="formgeneral-card-header">
                <div className="formgeneral-header-content">
                  <div className="formgeneral-header-title2">
                    <i className="fas fa-solid fa-envelope text-warning"></i> {t('Text_SENDEMAIL_Title')}
                  </div>
                  <div className="email-card-actions">
                    <button type="button" className="email-send-btn" onClick={handleSubmitDataEdit} >
                      {t('Text_Send').toUpperCase()}
                      <SendIcon sx={{ fontSize: 22, color: "white" }} />
                    </button> 
                     <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSendEMAILToSystem} >
                      {t('Menu_LogOut')}
                    </button>  
                  </div>
                </div>
              </div>
              <br/>
              {/* FORM CARD */}
              <div className="formgeneral-card-form">
                <div className="email-header-title2">{t('Text_SENDEMAIL_Data')}</div>
                <hr className="sidebar-divider d-none d-md-block"/> 

                 <div className="form-group">  
                  <div className="row p-2">
                    {/* Tipo de Incidencia */}
                    <label className="text-primary" style={{ fontSize: 18 }}>
                      {t('Text_SENDEMAIL_EmailsTo')} :
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="inicidents-input-wrapper">
                      <TextField
                        id="emailto"
                        name="emailto"
                        value={formEMAIL.emailto}
                        onChange={(e) => {
                          setFormEMAIL(prev => ({ ...prev, emailto: e.target.value.toLowerCase() }));
                          debouncedHandleSearchEmail(e.target.value);
                        }}
                        onKeyDown={handleKeyDownEmail}
                        onBlur={(event) => {
                          if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                            handleBlur();
                          }
                        }}
                        label={
                          errorsEMAIL.emailto != null
                            ? t(errorsEMAIL.emailto)
                            : t('PlaceHolder_SENDEMAIL_EmailsTo')
                        }
                        placeholder={t('PlaceHolder_SENDEMAIL_EmailsTo')}
                        variant="standard"
                        inputProps={{ style: { width: i18n.language === 'es' ? 704 : 829 } , maxLength: 255 }}
                        InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                      />

                      {filteredEmail.length > 0 && (
                        <div className="inicidents-suggest-dropdown" onMouseDown={(e) => e.preventDefault()}>
                          {filteredEmail.map((store, index) => (
                            <MenuItem
                              key={store.id}
                              onClick={() => handleSelectEmail(store)}
                              style={{
                                cursor: "pointer",
                                padding: "10px 12px",
                                borderBottom: "1px solid #eee",
                                fontSize: 18,
                                backgroundColor: index === highlightedIndexEmail ? "#4e73df" : "transparent",
                                color: index === highlightedIndexEmail ? "white" : "black",
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                            >
                              {store.email}
                            </MenuItem>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>  
                </div>  

                <div className="form-group">  
                  <div className="row p-2">
                    {/* Tipo de Incidencia */}
                    <label className="text-primary" style={{ fontSize: 18 }}>
                      {t('Text_SENDEMAIL_InicidentType')} :
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                      id="incidenttype_id"
                      name="incidenttype_id"
                      value={ (formEMAIL.incidenttype_id === undefined || formEMAIL.incidenttype_id ===null || formEMAIL.incidenttype_id ===""
                          || formEMAIL.incidenttype_id ==="0" || formEMAIL.incidenttype_id ===0)?defaultIncidenteType.id:formEMAIL.incidenttype_id}
                      inputProps={{ style: { width: i18n.language === "es" ? 639 : 676, fontSize: '18px' }}}
                      InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                      variant="outlined"
                      onBlur={handleBlurInicidentType}
                      onChange={handleChangeInicidentType}
                      helperText={errorsEMAIL.incidenttype_id!=null && errorsEMAIL.incidenttype_id!==""?t(errorsEMAIL.incidenttype_id):""}
                      select
                      SelectProps={{
                          native: true,
                          value: (formEMAIL.incidenttype_id === undefined || formEMAIL.incidenttype_id ===null || formEMAIL.incidenttype_id ===""
                              || formEMAIL.incidenttype_id ==="0" || formEMAIL.incidenttype_id ===0)?defaultIncidenteType.id: formEMAIL.incidenttype_id
                      }}>
                      <option key={0} value=""/>
                      {incidenteTypeToSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                            {i18n.language==='es'?option.namees:option.nameen}
                          </option>
                      ))}
                    </TextField>   
                  </div>  
                </div>  
                
                <div className="form-group">  
                  <div className="row p-2">
                    {/* Asunto */}
                    <label className="text-primary" style={{ fontSize: 18 }}>
                      {t('Text_SENDEMAIL_Subject')} :
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                      id="subjectEmail"
                      name="subjectEmail"
                      value={formEMAIL.subjectEmail || ""}
                      inputProps={{
                        style: { width: i18n.language === "es" ? 893 : 889, fontSize: '18px' },
                        maxLength: 100
                      }}
                      InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                      label={errorsEMAIL.subjectEmail? t(errorsEMAIL.subjectEmail):t('PlaceHolder_SENDEMAIL_Subject')}
                      placeholder={t('PlaceHolder_SENDEMAIL_Subject')}
                      variant="standard"
                      onBlur={handleBlurDataEditEmail}
                      onChange={handleChangeDataEditEmail}
                    />
                  </div>
                </div>
                <div className="form-group">  
                  <div className="row p-2">
                   {/* Contenido */}
                    <label className="text-primary" style={{ fontSize: 18 }}>
                      {t('Text_SENDEMAIL_Content')} :
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Textarea
                      id="contentEmail"
                      name="contentEmail"
                      value={formEMAIL.contentEmail}
                      label={errorsEMAIL.contentEmail?t(errorsEMAIL.contentEmail):t('PlaceHolder_SENDEMAIL_Content')}
                      placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                      sx={{ width:i18n.language === "es" ? 872 : 891, fontSize: '18px' }}
                      variant="standard"
                      onBlur={handleBlurDataEditEmail}
                      onChange={handleChangeDataEditEmail}
                      minRows={10}
                      maxRows={15}
                    /> 
                  </div>
                </div>  
                {!isLoadingData ? (
                  <div className="form-group">
                    <div className="row p-2">
                      <div className="upload-box" style={{ width: '100%' }}>
                        <div className="upload-title">{t('Text_Select_Files')}</div>
                        <DropzoneAreaBase
                          initialFiles={files}
                          fileObjects={files}
                          acceptedFiles={[/* ...tus tipos... */]}
                          maxFileSize={20000000}
                          filesLimit={5}
                          onAdd={handleAddFileContract}
                          onDelete={handleDeleteFileContract}
                          showAlerts={false}
                          getPreviewIcon={handlePreviewIcon}
                          dropzoneText={t('Text_Select_Files')}
                          showPreviews
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                          previewChipProps={{ classes: { root: 'upload-preview-chip' } }}
                          classes={{
                            root: 'upload-dropzone-root',
                            icon: 'upload-dropzone-icon',
                            text: 'upload-dropzone-text',
                          }}
                        />
                        {filesImages.length > 0 && (
                          <div className="preview-thumbnails-wrapper">
                            <div className="preview-thumbnails">
                              {filesImages.map((fileObj, index) => (
                                <div key={index} className="thumbnail-container">
                                  <img
                                    src={fileObj.data}
                                    alt={`preview-${index}`}
                                    className="thumbnail-image"
                                  /> 
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteImage(fileObj)}
                                    className="thumbnail-delete-btn"
                                    title={t('Text_Delete')}
                                  >
                                    &times;
                                  </button> 
                                  <button
                                    type="button"
                                    onClick={() => setPreviewImage(fileObj.data)}
                                    className="thumbnail-zoom-btn"
                                    title={t('Text_Zoom')}
                                  >
                                    🔍
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                       
                        <div className="audio-recorder-card">
                          <div className="audio-recorder-controls">
                            <img src={image1} alt="Camera Icon" style={{ width: 50, height: 50 }} />
                            <button type="button" className="btn-blue-outline" onClick={() => setShowCameraModal(true)} >
                              {t('Button_TakePhoto')}
                            </button>
                            {/* si tu AudioRecorder admite className */}
                            <AudioRecorder
                              className="audio-recorder"
                              onAudioRecorded={(file) => {
                                if (file) {
                                  setFiles(prev => [...prev, { file, data: URL.createObjectURL(file) }]);
                                } else {
                                  setFiles(prev => prev.filter(f => !f.file.type?.startsWith('audio/')));
                                }
                              }}
                            /> 
                          </div> 
                        </div> 
                      </div>
                    </div>
                  </div>

                ) : (
                  <LoadingNews />
                )} 
              </div>
            </div>
          </Box>
         {previewImage && (
            <div className="preview-modal-overlay">
              <div className="preview-modal-content">
                <button
                  type="button"
                  onClick={() => setPreviewImage(null)}
                  className="preview-close-button"
                  title={t('Text_Close')}
                >
                  &times;
                </button> 
                <img
                  src={previewImage}
                  alt={t('Text_View_Great')}
                  className="preview-image"
                />
              </div>
            </div>
          )} 
        
          {showCameraModal && (
            <div className="camera-modal-overlay">
              <div className="camera-modal-content">
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  width="320"
                  height="240"
                  className="camera-video"
                />
                <canvas ref={canvasRef} style={{ display: 'none' }} />
                <div className="camera-buttons">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      const video = videoRef.current;
                      const canvas = canvasRef.current;
                      const context = canvas.getContext('2d');
                      canvas.width = video.videoWidth;
                      canvas.height = video.videoHeight;
                      context.drawImage(video, 0, 0, canvas.width, canvas.height);
                      const dataUrl = canvas.toDataURL('image/jpeg');
                      handleAddImage([{ data: dataUrl }]);
                      setShowCameraModal(false);
                      if (video.srcObject) {
                        video.srcObject.getTracks().forEach(track => track.stop());
                      }
                    }}
                  >
                    📸 {t('Button_Capture')}
                  </button> 
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      const video = videoRef.current;
                      if (video.srcObject) {
                        video.srcObject.getTracks().forEach(track => track.stop());
                      }
                      setShowCameraModal(false);
                    }}
                  >
                    ❌ {t('Button_Cancel')}
                  </button>
                </div>
              </div>
            </div>
          )} 
          {/* End Content Row */}
        </div>
      )}
    </div>
  );
};

SendEMAILToSystem.propTypes = {
  showModalSentInicidents: PropTypes.bool.isRequired  
};

export default SendEMAILToSystem;